import { useRecoilState } from "recoil";
import { settingsMenuAtom } from "../../atoms/settingsMenuAtom";
import { TILES } from "../../helpers/tiles";
import Sprite from "../object-graphics/Sprite";
import { useRef } from "react";

export default function SettingsButton() {
  const buttonRef = useRef();
  const [isSettingsMenuOpen, setIsSettingsMenuOpen] =
    useRecoilState(settingsMenuAtom);

  return (
    <button
      ref={buttonRef}
      onClick={() => {
        const nextValue = !isSettingsMenuOpen;
        setIsSettingsMenuOpen(nextValue);
        //Blur to not have focus on this
        if (!nextValue) {
          buttonRef.current.blur();
        }
      }}
    >
      <Sprite frameCoord={TILES.SETTINGS} />
    </button>
  );
}
